import { ElMessage, ElMessageBox } from "element-plus";
import { ref, reactive } from "vue";
import { GetPage, Delete } from "@/api/keyMaterial";
import { postDownload } from "@/utils";

export default function useStashTable() {
  const searchRef = ref(null); // 搜索ref
  // 搜索条件
  const searchData = reactive({
    number: null,
    scrapDate: [],
    scrapInDate: [],
  });
  const adjustRef = ref(null); // 新增弹窗ref

  const tableLoading = ref(false); // 表格loading
  //  <!-- number: null,
  //   scrapTime: null,
  //   scrapInTime: null,
  //   warehouseName: null,
  //   createTime: null, -->
  // 表格列配置
  const columns = ref([
    {
      label: "表具编号",
      prop: "number",
    },
    {
      label: "报废日期",
      prop: "scrapTime",
    },
    {
      label: "报废入库日期",
      prop: "scrapInTime",
    },
    {
      label: "报废入库仓库",
      prop: "warehouseName",
    },
    {
      label: "创建时间",
      prop: "createTime",
    },
  ]);

  // 表格数据
  const tableData = ref([]);

  // 分页参数
  const pages = reactive({
    page: 1,
    size: 10,
    total: 0,
  });
  const handleSizeChange = (val) => {
    pages.size = val;
    pages.page = 1;
    getList();
  };
  const handleCurrentChange = (val) => {
    pages.page = val;
    getList();
  };

  // 获取列表数据
  const getList = () => {
    tableLoading.value = true;
    GetPage({
      ...searchData,
      page: pages.page,
      limit: pages.size,
      startTime: searchData.scrapDate[0]
        ? searchData.scrapDate[0] + " 00:00:00"
        : null,
      endTime: searchData.scrapDate[1]
        ? searchData.scrapDate[1] + " 23:59:59"
        : null,
      startTimeIn: searchData.scrapInDate[0]
        ? searchData.scrapInDate[0] + " 00:00:00"
        : null,
      endTimeIn: searchData.scrapInDate[1]
        ? searchData.scrapInDate[1] + " 23:59:59"
        : null,
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 搜索条件重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    searchData.number = null;
    searchData.scrapDate = [];
    searchData.scrapInDate = [];
    pages.page = 1;
    getList();
  };

  // 点击新增或编辑或详情
  // config: row, type
  const handleAdjust = (row, type) => {
    adjustRef.value?.handleDialogOpen(row, type);
  };

  // （批量）删除
  const handleDelete = (id) => {
    ElMessageBox.confirm("确定删除所选数据吗？", "删除", {
      confirmButtonText: "删除",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        Delete(id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getList();
          }
        });
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  // 点击导出

  return {
    searchRef,
    searchData,
    tableLoading,
    columns,
    tableData,
    pages,
    adjustRef,
    getList,
    handleSizeChange,
    handleCurrentChange,
    handleReset,
    handleAdjust,
    handleDelete,
  };
}
